/*
 * UrlUtils.ts
 */
export function buildQueryParameters(keyAndValues) {
  let encodeValueAsURI = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  let queryParamsString = "";
  for (const key in keyAndValues || []) {
    if (keyAndValues.hasOwnProperty(key)) {
      const value = keyAndValues[key];
      if (value !== null && value !== undefined && typeof value !== "object") {
        const prefix = !queryParamsString ? "" : "&";
        const encodedValue = encodeValueAsURI ? encodeURIComponent(value) : value;
        const queryParamItem = `${key}=${encodedValue}`;
        queryParamsString += prefix + queryParamItem;
      }
    }
  }
  return queryParamsString;
}